import React from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';

const AnimatedButton = ({ buttonName, className, handleClick,link, id, disabled,loading }) => {
    const location=useNavigate()
    return (
        <>
            {
                loading ? <Loader  colorCode={"#106eb4"}/> : <motion.button
                    type='button'
                    //whileHover={{ scale: 1.05 }}
                    className={className}
                    disabled={disabled === undefined ? false : disabled}
                    onClick={(e) => {
                        if (link) {
                            location(link)
                        } else {
                            handleClick(e)
                        }
                    }}
                    id={id === undefined ? buttonName : id}
                    //when button is loading, removing cursor
                    style={{
                        ...(disabled && {
                            cursor: 'default'
                        })
                    }}
                >
                    {buttonName}
                </motion.button>
            }
        </>
        
    );
}

export default AnimatedButton;
